import { useSalesTerm } from "@/components/features/items/edit/_shared/ui/components/main/questions/sales-term/hooks";

import { useProductOptionFormModelContext } from "../../../../context";

export const useOptionSalesTerm = () => {
	const { viewModel, onSetViewModel } = useProductOptionFormModelContext();
	const { saleTypeForTerm, saleStart, saleEnd, stayableStart, stayableEnd } = viewModel;

	return useSalesTerm({
		saleTypeForTerm,
		saleStart,
		saleEnd,
		stayableStart,
		stayableEnd,
		onSetViewModel,
	});
};
